import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { useTranslation, formatDateTime, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau3 = ({ dataMatch, dataMatchDetail, size, id, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100

    const color = {
        first: '#FFD700',    // Metallic Gold
        second: '#FFF0A0',   // Pale Gold
        third: '#B8860B',    // Dark Golden Rod
        fourth: '#e0c060',   // Muted Gold
        text: '#ffffff',
        bg: '#0a0a0a'        // Jet Black
    }

    const arrNameRound = { quarterfinals: 'TỨ KẾT', semifinal: 'BÁN KẾT', '3rdPlace': 'TRANH HẠNG 3', final: 'CHUNG KẾT' }

    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    let teamHomeRankName = arrRankName.includes?.(dataMatch.homeTeam?.rankName) ? `${t(dataMatch.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(dataMatch.awayTeam?.rankName) ? `${t(dataMatch.awayTeam?.rankName)}` : ''

    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

    let teamHomeName = arrName.includes(dataMatch.homeTeam?.name) || !dataMatch.homeTeam?.id ? `${t(dataMatch.homeTeam?.name) || dataMatch.homeTeam?.name}` : dataMatch.homeTeam?.name
    let teamAwayName = arrName.includes(dataMatch.awayTeam?.name) || !dataMatch.awayTeam?.id ? `${t(dataMatch.awayTeam?.name) || dataMatch.awayTeam?.name}` : dataMatch.awayTeam?.name

    let homeName = dataMatch?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = dataMatch.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

    const roundLabel = arrNameRound[dataMatch?.numberRound] || (dataMatch?.numberRound ? `${t('round')} ${dataMatch?.numberRound}` : '')

    return (
        <div id={id} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative', overflow: 'hidden' }}>

            {/* Gold dust particle overlay */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                background: 'radial-gradient(ellipse at 50% 30%, rgba(255,215,0,0.07) 0%, transparent 60%)'
            }} />
            {/* Subtle diagonal lines texture */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                backgroundImage: `repeating-linear-gradient(45deg, rgba(255,215,0,0.02) 0px, rgba(255,215,0,0.02) 1px, transparent 1px, transparent 8px)`
            }} />

            <div style={{ position: 'relative', zIndex: 1, width: '100%', minHeight: `calc(${width / 1.3}px - ${3.2 * px}px)`, padding: `${px * 1.5}px`, display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: `${px * 1.5}px`, marginBottom: `${px * 1.5}px`, borderBottom: `1px solid rgba(255,215,0,0.3)` }}>
                    <div style={{ flex: 1 }}>
                        <Image src={dataMatch?.season?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, objectFit: 'contain', filter: `drop-shadow(0 0 6px rgba(255,215,0,0.8))` }} />
                    </div>
                    <div style={{ flex: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h1 style={{ textAlign: 'center', color: color.fourth, fontSize: `${2.6 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 10px rgba(255,215,0,0.5)`, margin: 0 }}>{dataMatch?.season?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Image src={img} style={{ width: `${px * 9}px`, height: `${px * 9}px`, objectFit: 'contain', filter: `drop-shadow(0 0 4px rgba(255,215,0,0.4))` }} />
                    </div>
                </div>

                {/* MATCH DAY title */}
                <div style={{ textAlign: 'center', marginBottom: `${px * 0.5}px` }}>
                    <h1 style={{
                        color: color.first,
                        fontSize: `${6 * px}px`,
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        letterSpacing: `${px * 0.5}px`,
                        textShadow: `0 0 15px rgba(255,215,0,0.6), 0 2px 4px rgba(0,0,0,0.8)`,
                        margin: 0,
                        lineHeight: 1.1,
                        background: `linear-gradient(180deg, #FFF0A0 0%, #FFD700 50%, #B8860B 100%)`,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                    }}>MATCH DAY</h1>
                </div>

                {/* Gold divider */}
                <div style={{ width: '80%', margin: `0 auto ${px * 1.5}px`, height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${color.first}, transparent)` }} />

                {/* Round badge */}
                {roundLabel && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: `${px * 2}px` }}>
                        <div style={{ background: `linear-gradient(135deg, rgba(255,215,0,0.15), rgba(184,134,11,0.1))`, border: `1px solid rgba(255,215,0,0.5)`, borderRadius: `${px * 3}px`, padding: `${px * 0.6}px ${px * 4}px`, boxShadow: `0 0 12px rgba(255,215,0,0.15)` }}>
                            <span style={{ color: color.first, fontSize: `${2.2 * px}px`, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px' }}>{roundLabel}</span>
                        </div>
                    </div>
                )}

                {/* Team logos + VS */}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', padding: `0 ${px * 2}px`, marginBottom: `${px * 1.5}px` }}>

                    {/* Home team logo */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                        <div style={{
                            borderRadius: '50%',
                            padding: `${px * 0.8}px`,
                            background: `radial-gradient(circle, rgba(255,215,0,0.1) 0%, rgba(10,10,10,0.8) 100%)`,
                            border: `${px * 0.5}px solid ${color.first}`,
                            boxShadow: `0 0 20px rgba(255,215,0,0.4), 0 0 40px rgba(255,215,0,0.15), inset 0 0 15px rgba(255,215,0,0.05)`
                        }}>
                            <Image src={dataMatch?.homeTeam?.logo} style={{ width: `${20 * px}px`, height: `${20 * px}px`, borderRadius: '50%', objectFit: 'contain', backgroundColor: 'rgba(255,255,255,0.05)' }} />
                        </div>
                    </div>

                    {/* VS */}
                    <div style={{ flex: 0.5, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{
                            fontSize: `${6 * px}px`,
                            fontWeight: 'bold',
                            lineHeight: 1,
                            background: `linear-gradient(180deg, #FFF0A0 0%, #FFD700 50%, #B8860B 100%)`,
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            textShadow: 'none',
                            filter: `drop-shadow(0 0 8px rgba(255,215,0,0.5))`
                        }}>VS</span>
                    </div>

                    {/* Away team logo */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                        <div style={{
                            borderRadius: '50%',
                            padding: `${px * 0.8}px`,
                            background: `radial-gradient(circle, rgba(255,215,0,0.1) 0%, rgba(10,10,10,0.8) 100%)`,
                            border: `${px * 0.5}px solid ${color.first}`,
                            boxShadow: `0 0 20px rgba(255,215,0,0.4), 0 0 40px rgba(255,215,0,0.15), inset 0 0 15px rgba(255,215,0,0.05)`
                        }}>
                            <Image src={dataMatch?.awayTeam?.logo} style={{ width: `${20 * px}px`, height: `${20 * px}px`, borderRadius: '50%', objectFit: 'contain', backgroundColor: 'rgba(255,255,255,0.05)' }} />
                        </div>
                    </div>
                </div>

                {/* Team names */}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', padding: `0 ${px * 2}px`, marginBottom: `${px * 2.5}px` }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Name propClass={`home${dataMatch?.homeTeam?.id}${new Date().getTime()}`} name={homeName} px={px} />
                    </div>
                    <div style={{ flex: 0.5 }} />
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Name propClass={`away${dataMatch?.awayTeam?.id}${new Date().getTime()}`} name={awayName} px={px} />
                    </div>
                </div>

                {/* Score or Time */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: `${px * 2}px` }}>
                    {dataMatch?.isCompleted ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {/* Score box */}
                            <div style={{
                                background: 'rgba(10,10,10,0.9)',
                                border: `${px * 0.3}px solid ${color.first}`,
                                borderRadius: `${px * 1.5}px`,
                                padding: `${px}px ${px * 6}px`,
                                boxShadow: `0 0 25px rgba(255,215,0,0.3), inset 0 0 15px rgba(255,215,0,0.05)`,
                                marginBottom: `${px}px`
                            }}>
                                <div style={{ color: color.first, fontSize: `${8 * px}px`, letterSpacing: `${px * 0.5}px`, textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 15px rgba(255,215,0,0.5)`, whiteSpace: 'nowrap' }}>
                                    {!dataMatch?.homeTeam?.isGiveUp && !dataMatch?.awayTeam?.isGiveUp && `${dataMatch?.homeTeam?.score} - ${dataMatch?.awayTeam?.score}`}
                                    {dataMatch?.homeTeam?.isGiveUp && !dataMatch?.awayTeam?.isGiveUp && `0 - ${dataMatch?.awayTeam?.giveUpScore}`}
                                    {!dataMatch?.homeTeam?.isGiveUp && dataMatch?.awayTeam?.isGiveUp && `${dataMatch?.homeTeam?.giveUpScore} - 0`}
                                    {dataMatch?.homeTeam?.isGiveUp && dataMatch?.awayTeam?.isGiveUp && `-`}
                                </div>
                            </div>
                            {/* DateTime */}
                            <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: `${1.8 * px}px`, textAlign: 'center' }}>
                                {formatDateTime(dataMatch?.dateTime, 'dateTime')}
                            </div>
                            {/* Penalty */}
                            {dataMatch?.hasPenalty && (
                                <div style={{ color: color.second, fontSize: `${1.8 * px}px`, marginTop: `${px * 0.5}px`, fontWeight: 'bold', textAlign: 'center' }}>
                                    ({t('pk')}: {dataMatch?.homeTeam?.penaltyScore} - {dataMatch?.awayTeam?.penaltyScore})
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.5}px` }}>
                            {/* Stadium */}
                            {dataMatch?.stadium && (
                                <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: `${1.8 * px}px`, textAlign: 'center', textTransform: 'uppercase', marginBottom: `${px * 0.5}px` }}>
                                    {dataMatch?.stadium}
                                </div>
                            )}
                            {/* Date */}
                            <div style={{ color: color.second, fontSize: `${2.2 * px}px`, textAlign: 'center', fontWeight: 'bold' }}>
                                {formatDateTime(dataMatch?.dateTime, 'date')}
                            </div>
                            {/* Time box */}
                            <div style={{
                                background: 'rgba(10,10,10,0.9)',
                                border: `${px * 0.3}px solid ${color.first}`,
                                borderRadius: `${px * 1.5}px`,
                                padding: `${px * 0.8}px ${px * 5}px`,
                                boxShadow: `0 0 20px rgba(255,215,0,0.25)`
                            }}>
                                <div style={{ color: color.first, fontSize: `${6 * px}px`, letterSpacing: '4px', textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 12px rgba(255,215,0,0.5)` }}>
                                    {formatDateTime(dataMatch?.dateTime, 'time')}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Gold divider */}
                <div style={{ width: '100%', height: `${px * 0.15}px`, background: `linear-gradient(90deg, transparent, ${color.first}, transparent)`, marginBottom: `${px * 2}px`, opacity: 0.35 }} />

                {/* Sponsors */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: `${px}px`, background: 'rgba(10,10,10,0.8)', borderRadius: `${px * 2}px`, flexWrap: 'wrap', border: `1px solid rgba(255,215,0,0.15)`, marginBottom: `${px * 2}px` }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', margin: `0 ${px}px` }} />)}
                    </div>
                )}

                {/* Footer */}
                <p style={{ textAlign: 'right', color: `rgba(224,192,96,0.5)`, fontSize: `${1.8 * px}px`, fontWeight: 'bold', margin: 0 }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS EXCLUSIVE'}
                </p>

            </div>
        </div>
    )
}

const Name = React.memo(
    ({ name, px, propClass }) => {
        const reSizeBasedOnWidth = () => {
            let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
            if (fontSize) {
                document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.3 * px + 'px'
                if (document.querySelector(`.${propClass}`).scrollHeight > document.querySelector(`.contain${propClass}`).clientHeight) {
                    reSizeBasedOnWidth()
                }
            }
        }
        const processInput = () => {
            if (document.querySelector(`.${propClass}`)) {
                document.querySelector(`.${propClass}`).innerHTML = name
                document.querySelector(`.${propClass}`).style.fontSize = px * 3.5 + 'px'
                reSizeBasedOnWidth()
            }
        }

        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div className={`contain${propClass}`} style={{ width: '100%', height: `${8 * px}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <h2 className={propClass} style={{ color: '#ffffff', textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, width: '100%' }}></h2>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataMatch) === JSON.stringify(n.dataMatch) &&
        JSON.stringify(p.dataMatchDetail) === JSON.stringify(n.dataMatchDetail) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau3, areEqual)
